import { formatAPIDate } from "../libs/common_utils";

// For the new-to-brand report. Gets from WL DB rather than Reporting API.
export default class NewToBrandReportModel {
  constructor({
    startDate = null,
    endDate = null,
    campaignIds = [],
    dimensions = [],
    metrics = [],
    output = "json",
    lookbackWindow = null,
    advertiserId = null,
  } = {}) {
    this.campaign_ids = campaignIds;
    this.dimensions = dimensions;
    this.metrics = metrics;
    this.output = output;
    this.start_date = startDate;
    this.end_date = endDate;
    this.lookback_window = lookbackWindow;
    this.advertiser_id = advertiserId;
  }

  /**
   * convert model into json format
   * @return {object}
   */
  toJson() {
    const json = { ...this };

    json.start_date = formatAPIDate(this.start_date);
    json.end_date = formatAPIDate(this.end_date);

    return json;
  }
}
